import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AppContainer from './container/AppContainer';
import registerServiceWorker from './registerServiceWorker';
import {
  createStore,
  applyMiddleware,
  compose
} from 'redux';
import thunkMiddleware from 'redux-thunk';
import { Provider } from 'react-redux';
import reducer from './reducers';

function configureStore(initialState) {
  const enhancer = compose(
    applyMiddleware(thunkMiddleware)
  );
  return createStore(reducer, initialState, enhancer);
}

const store = configureStore({});

ReactDOM.render(
  <Provider store={store}>
    <AppContainer />
  </Provider>,
  document.getElementById('root')
)

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js